'use strict';

var bind = require('function-bind');

var $apply = require('./functionApply');
var $call = require('./functionCall');
var $reflectApply = require('./reflectApply');

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);



//////////////////
// WEBPACK FOOTER
// ./~/_call-bind-apply-helpers@1.0.2@call-bind-apply-helpers/actualApply.js
// module id = 447
// module chunks = 0